import React, { PureComponent } from 'react';
import { withStyles, Paper, Table, TableHead, TableBody, TableRow, TableCell, 
  Toolbar, Typography, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import PropTypes from 'prop-types';
import { Checkbox, Dialog } from '@blueprintjs/core';

const styles = theme => ({
  root: {
    maxWidth: 1060,
    margin: 'auto',
  },
  toolbar: {
    paddingRight: theme.spacing.unit,
  },
  spacer: {
    flexGrow: 1,
  },
  title: {
    flex: '0 0 auto',
  },
  tablerow: {
    height: 36
  },
});

class MembersList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      selectedMember: null,
      selectedMemberIndex: null,
      userIsAdmin: false,
    };

    this.changedFirstName = null;
    this.changedLastName = null;
    this.changedEmail = null;
    this.changedCellPhone = null;
  }

  componentDidMount() {
    const { getMembersList, fetchingMembersList } = this.props;
    if (fetchingMembersList !== 'Loading' || fetchingMembersList !== 'Loaded') {
      getMembersList();
    }

    const token = localStorage.getItem('kodaro-token');
    const decodedToken = token ? atob(token.split(".")[1]) : null;
    const parsedToken = decodedToken ? JSON.parse(decodedToken) : null;
    this.setState({ userIsAdmin: parsedToken.userType === "Admin" });
  }

  updateMemberAdmin = () => {
    let updatedMember = { ...this.state.selectedMember, isAdmin: !this.state.selectedMember.isAdmin };
    this.setState({ selectedMember: updatedMember });
  };

  updateMemberUmp = () => {
    let updatedMember = { ...this.state.selectedMember, isUmpire: !this.state.selectedMember.isUmpire };
    this.setState({ selectedMember: updatedMember });
  };

  handleCellPhoneChange = (e) => {
    this.changedCellPhone = e.target.value;
  };

  handleEmailChange = (e) => {
    this.changedEmail = e.target.value;
  };

  handleFirstNameChange = (e) => {
    this.changedFirstName = e.target.value;
  };

  handleLastNameChange = (e) => {
    this.changedLastName = e.target.value;
  };

  getUpdatedMember = (member) => {
    if (this.changedFirstName !== null){
      member.firstName = this.changedFirstName;
    }
    if (this.changedLastName !== null){
      member.lastName = this.changedLastName;
    }
    if (this.changedEmail !== null){
      member.email = this.changedEmail;
    }
    if (this.changedCellPhone !== null){
      member.cellPhone = this.changedCellPhone;
    }
    return member;
  };

  updateMember = async () => {
    const { selectedMember, originalMember } = this.state;

    if (selectedMember.isAdmin !== originalMember.isAdmin) {
      this.props.userRoleUpdate(selectedMember.memberId, selectedMember.email, selectedMember.isAdmin);
    } else if (selectedMember.isUmpire !== originalMember.isUmpire) {
      this.props.updateUmp(selectedMember.memberId, 0, null, null, null, selectedMember.isUmpire, null);
    }

    const modifiedMember = this.getUpdatedMember({ ...selectedMember  });

    // ✅ Proper change detection
    if (
      this.changedFirstName !== null ||
      this.changedLastName !== null ||
      this.changedEmail !== null ||
      this.changedCellPhone !== null
    ) {
      const response = await this.props.userInfoUpdate(
        modifiedMember.memberId, 
        modifiedMember.email, 
        modifiedMember.firstName, 
        modifiedMember.lastName, 
        modifiedMember.cellPhone
      );

      let updatedMember = { 
        ...this.state.selectedMember, 
        firstName: response.firstName,
        lastName: response.lastName,
        email: response.email,
        cellPhone: response.cellPhone,
      };

      this.setState({ selectedMember: updatedMember });

      this.props.getMembersList();
    }

    // 🔥 Reset change tracking after save
    this.changedFirstName = null;
    this.changedLastName = null;
    this.changedEmail = null;
    this.changedCellPhone = null;

    this.setState({ isOpen: false });
  };

  toggleDialog = (index) => {
    const selectedMember = this.props.membersList[index];
    this.setState({ 
      isOpen: !this.state.isOpen, 
      selectedMember,
      originalMember: { ...selectedMember }, // snapshot original
      selectedMemberIndex: index 
    });
  };

  closeDialog = event => {
    event.preventDefault();

    // 🔥 Reset on close as well
    this.changedFirstName = null;
    this.changedLastName = null;
    this.changedEmail = null;
    this.changedCellPhone = null;

    this.setState({ isOpen: false, selectedMember: null, selectedMemberIndex: null });
  };

  render() {
    const { classes, fetchingMembersList } = this.props;
    const { isOpen } = this.state;
    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.title}>
            <Typography variant="h5">Member Table</Typography>
          </div>
          <div className={classes.spacer} />
        </Toolbar>
        <Table padding="none">
          <TableHead>
            <TableRow>
              <TableCell align="center"><Typography variant="body1">Member ID</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Member</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Email</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Phone</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Players</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1"></Typography></TableCell>
            </TableRow>
          </TableHead>
          {fetchingMembersList === 'Loaded' && this.renderTableBody()}
        </Table>
        {fetchingMembersList === 'Loaded' && (isOpen) && this.renderDialog()}
      </Paper>
    );
  }

  renderTableBody() {
    const { classes, membersList } = this.props;

    return (
      <TableBody>
        {membersList.map((member, index) => {
          return (
            <TableRow className={classes.tablerow} key={`${member.memberId}`} hover>
              <TableCell align="center"><Typography variant="body2">{member.memberId}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">{member.firstName} {member.lastName}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">{member.email}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">{member.cellPhone}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">{member.playerNames}</Typography></TableCell>
              <TableCell align="center">
                <IconButton
                  size="small" color="primary"
                  onClick={() => {this.toggleDialog(index)}}
                >
                  <EditIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  }

  renderDialog() {
    const { isOpen, selectedMember } = this.state;

    return (
      <Dialog
        key={selectedMember ? selectedMember.memberId : 'empty'} // ✅ force re-render
        className="members-table-dialog"
        title="Edit Member"
        isOpen={isOpen}
        onClose={this.closeDialog}
      >
        <div className="pt-dialog-body">
          <label className="pt-label pt-inline">
            Member Id:
            <input
              type="text"
              className="pt-input"
              value={selectedMember === null ? '' : selectedMember.memberId}
              readOnly
            />
          </label>
          <label className="pt-label pt-inline">
            First Name:
            <input 
              type="text"
              className="pt-input"
              defaultValue={selectedMember === null ? '' : selectedMember.firstName}
              onChange={this.handleFirstNameChange}
              readOnly={!this.state.userIsAdmin}
            />
          </label>
          <label className="pt-label pt-inline">
            Last Name:
            <input
              type="text"
              className="pt-input"
              defaultValue={selectedMember === null ? '' : selectedMember.lastName}
              onChange={this.handleLastNameChange}
              readOnly={!this.state.userIsAdmin} 
            />
          </label>
          <label className="pt-label pt-inline">
            Email:
            <input
              type="text"
              className="pt-input"
              defaultValue={selectedMember === null ? '' : selectedMember.email}
              onChange={this.handleEmailChange}
              readOnly={!this.state.userIsAdmin}
            />
          </label>
          <label className="pt-label pt-inline">
            Phone Number:
            <input
              type="text"
              className="pt-input"
              defaultValue={selectedMember === null ? '' : selectedMember.cellPhone}
              onChange={this.handleCellPhoneChange}
              readOnly={!this.state.userIsAdmin} 
            />
          </label>
          <label className="pt-label pt-inline">
            Umpire:
            <Checkbox
              id="isUmpire"
              checked={selectedMember === null ? '' : selectedMember.isUmpire}
              onChange={this.updateMemberUmp}
            />
          </label>
          <label className="pt-label pt-inline">
            Site Admin:
            <Checkbox
              id="isAdmin"
              checked={selectedMember === null ? '' : selectedMember.isAdmin}
              onChange={this.updateMemberAdmin}
            />
          </label>
          <div className="dialog-btn-container">
            <button className="pt-button" onClick={this.updateMember}>
              Save
            </button>
          </div>
        </div>
      </Dialog>
    );
  }
}

MembersList.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(MembersList);


// WEBPACK FOOTER //
// ./src/components/MembersList.js